/* Founders Studio paired add ons. A product with a "Pairs with" product (metafield custom.bag_pairing) offers it in the bag in place of the store wide order bump, and the product page adds it in 1 tap. */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function data(){try{return JSON.parse((document.getElementById('xBagData')||{}).textContent||'{}')}catch(e){return {}}}
  function card(b){return '<div class="x-bump" data-x-pair><figure>'+(b.img?'<img src="'+esc(b.img)+'" alt="">':'')+'</figure><span><span class="x-k">'+esc(b.kicker||'')+'</span><b>'+esc(b.title)+'</b><small>'+(b.sub?esc(b.sub)+' &#183; ':'')+(b.was?'<s style="color:#8a877e">'+esc(b.was)+'</s> ':'')+esc(b.price)+'</small></span><button type="button" data-x-bump="'+b.id+'">Add</button></div>'}
  function bag(){
    var X=document.querySelector('[data-x-extras]');if(!X)return;
    var P=data().pairs||{},busy=false;
    if(!Object.keys(P).length)return;
    function swap(){
      if(busy||!X.innerHTML)return;busy=true;
      fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
        var have={},pick=null;(cart.items||[]).forEach(function(it){have[it.product_id]=1});
        (cart.items||[]).some(function(it){var q=P[it.product_id];if(q&&!have[q.pid]){pick=q;return true}return false});
        if(!pick||X.querySelector('[data-x-pair]')){busy=false;return}
        var tmp=document.createElement('div');tmp.innerHTML=card(pick);var el=tmp.firstChild;
        var old=X.querySelector('.x-bump');
        if(old)X.replaceChild(el,old);else{var nx=X.querySelector('.x-next');if(nx)X.insertBefore(el,nx);else X.appendChild(el)}
        setTimeout(function(){busy=false},50);
      }).catch(function(){busy=false});
    }
    if('MutationObserver' in window)new MutationObserver(function(){if(!X.querySelector('[data-x-pair]'))swap()}).observe(X,{childList:true});
  }
  function pdp(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-x-padd]'),function(pb){
      pb.addEventListener('click',function(e){
        e.preventDefault();var id=+pb.getAttribute('data-x-padd'),l=pb.querySelector('[data-x-pl-lab]'),t=l?l.textContent:'';if(l)l.textContent='Adding';
        var C=window.VS_CART,done=function(){if(l){l.textContent='Added';setTimeout(function(){l.textContent=t},1400)}},fail=function(){if(l)l.textContent=t};
        if(C&&C.add){C.add(id,1).then(done,fail)}
        else{fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})}).then(function(){if(window.VS_DRAWER)window.VS_DRAWER.open()}).then(done,fail)}
      });
    });
  }
  function boot(){try{bag()}catch(e){}try{pdp()}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();